import { useEffect, useState } from "react";
import { getUser } from "./adminservice";

/* Droit de paiement de l'admin connecté (rôle : payment_write ; SUPER_ADMIN
   toujours). Le serveur le vérifie de toute façon : l'interface s'en sert
   seulement pour ne pas proposer une saisie qui serait refusée. */
export function useDroitPaiement(): boolean {
  const [droit, setDroit] = useState(false);
  useEffect(() => {
    let actif = true;
    getUser()
      .then((u: any) => { if (actif) setDroit(u?.role === "SUPER_ADMIN" || u?.role_type?.payment_write === true); })
      .catch(() => { if (actif) setDroit(false); });
    return () => { actif = false; };
  }, []);
  return droit;
}
